export default __webpack_public_path__ + "static/media/smallTruckLeftMobile.fd9a1d45.jpg";